import { allowedViewsForUser, routeForView, type FswlView } from "./viewAccess";
import type { AuthUser } from "./types";

export type { FswlView } from "./viewAccess";
export {
  activeViewFromPathname,
  allowedViewsForUser,
  canAccessView,
  routeForView,
  viewLabel,
} from "./viewAccess";

/** Route after login; extensible for future multi-view switcher. */
export function routeAfterLogin(
  user: AuthUser | null,
  locationState: unknown,
  preferredView?: Exclude<FswlView, "customer">,
): string {
  const from = (locationState as { from?: string } | null)?.from;
  if (!user) return "/login";

  const allowed = allowedViewsForUser(user);
  const view =
    preferredView && allowed.includes(preferredView) ? preferredView : (allowed[0] ?? "management");

  if (from && from !== "/login") {
    if (from.startsWith("/staff") && allowed.includes("staff")) return from;
    if (!from.startsWith("/staff") && allowed.includes("management")) return from;
  }

  return routeForView(view);
}
